export default {
  loading_menu: 'A carregar o menu...',
};
